import React, { type ReactNode } from 'react'
import classNames from 'classnames'
import bgSrc from '../../../../assets/images/post-connect-header-bg.svg?url'
import styles from './OnboardingStepHeader.module.scss'

export interface OnboardingStepHeaderProps {
  icon: ReactNode
  title: string
  subtitle?: ReactNode
  showDecoration?: boolean
  children?: ReactNode
}

export const OnboardingStepHeader: React.FC<OnboardingStepHeaderProps> = ({ icon, title, subtitle, showDecoration = true, children }) => (
  <div
    className={classNames(styles.header, 'position-relative d-flex flex-column align-items-center gap-1 pt-4 pb-3 px-3 overflow-hidden', {
      [styles.headerCompact]: !showDecoration,
    })}
  >
    {showDecoration ? (
      <div className={classNames(styles.bg, 'position-absolute top-0 d-flex align-items-center justify-content-center pe-none')} aria-hidden='true'>
        <img src={bgSrc} alt='' className={styles.bgIcon} />
      </div>
    ) : null}
    <div className={classNames(styles.icon, 'position-relative flex-shrink-0 lh-1 text-dark')}>{icon}</div>
    <p className={classNames(styles.title, 'position-relative mt-1 mb-0 fw-bold text-center text-dark')}>{title}</p>
    {subtitle ? <p className={classNames(styles.subtitle, 'position-relative m-0 fw-medium text-center text-secondary')}>{subtitle}</p> : null}
    {children}
  </div>
)
